import { render, staticRenderFns } from "./KitBuilder.vue?vue&type=template&id=70585a04&scoped=true&"
import script from "./KitBuilder.vue?vue&type=script&lang=ts&"
export * from "./KitBuilder.vue?vue&type=script&lang=ts&"
import style0 from "./KitBuilder.vue?vue&type=style&index=0&id=70585a04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70585a04",
  null
  
)

export default component.exports